import axios from 'axios';
import { store } from './store';

import { parseISO, format } from 'date-fns';
export const API_URL = process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LIVE;

export const apiAxios = axios.create({
    baseURL: API_URL
});

export const apiThirdPartyAxios = axios.create({
    baseURL: ''
});

const store_data = JSON.parse(store());
// console.log(store_data)

const getToken = async () => {
    return store_data?.token; // Get the token from the Redux store
};

const getConfig = async () => {
    const token = await getToken();
    // console.log("token", token)
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
        }
    };
};

const getConfigForm = async () => {
    const token = await getToken();
    return {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        }
    };
};

export const postAPI = async (apiName, data) => {
    const response = await apiAxios.post(`${API_URL}${apiName}`, { ...data, org_id: store_data?.org_id || data?.org_id }, await getConfig());
    return response.data;
};

export const postThirdPartyAPI = async (apiName, data) => {
    const response = await apiThirdPartyAxios.post(`${apiName}`, { ...data }, await getConfig());
    return response.data;
};

export const postAPIForm = async (apiName, data) => {
    const response = await apiAxios.post(`${API_URL}${apiName}`, data, await getConfigForm());
    return response.data;
};

export const getAPI = async (apiName) => {
    const response = await apiAxios.get(`${API_URL}${apiName}?org_id=${store_data?.org_id}`, await getConfig());
    return response.data;
};

export const getURL = () => {
    return process.env.REACT_APP_NODE_ENV === 'development' ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_LIVE;
};

export const formatDate = (dateString) => {
    const date = parseISO(dateString);
    const day = format(date, 'd');
    const month = format(date, 'MMM');
    const year = format(date, 'yyyy');
    return { day, month, year }
};

export const convertTo24Hour = (time12h) => {
    const [time, modifier] = time12h.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    } else if (modifier.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

// Example
// console.log(convertTo24Hour("2:30 PM")); // "14:30"
// console.log(convertTo24Hour("12:00 AM")); // "00:00"

export const convertTo12Hour = (time24h) => {
    let [hours, minutes] = time24h.split(':').map(Number);
    const modifier = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${hours}:${String(minutes).padStart(2, '0')} ${modifier}`;
}

// Example
//   console.log(convertTo12Hour("14:30")); // "2:30 PM"
//   console.log(convertTo12Hour("00:00")); // "12:00 AM"

export const splitISODateTime = (isoString) => {
    if (typeof isoString !== "string") return [null, null];

    const dateObj = new Date(isoString);
    if (isNaN(dateObj.getTime())) return [null, null];

    const date = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
    const time = dateObj.toISOString().slice(11, 19); // HH:MM:SS

    return [date, time];
};


// Example usage
//   const [date, time] = splitISODateTime("2025-05-04T14:30:00");
//   console.log(date); // "2025-05-04"
//   console.log(time); // "14:30:00"
